import planningPlanAccountsApi from '../planning-api';

// Tag Type Constants
const PLAN_TAG = 'Plan' as const;
const ACCOUNT_TAG = 'PlanAccount' as const;

// Tag Types
export const TAG_TYPES = [PLAN_TAG, ACCOUNT_TAG] as const;

// Cache Tags
export const CACHE_TAGS = {
  ACCOUNT: (accountId: string) => ({ type: ACCOUNT_TAG, id: accountId }) as const,
  PLAN: (planId: string) => ({ type: PLAN_TAG, id: planId }) as const,
} as const;

export const createPlanningCacheUtils = (api: typeof planningPlanAccountsApi) => ({
  /**
   * Force refresh plan data in background while serving cached data
   */
  refreshPlan: (planId: string) => api.util.invalidateTags([CACHE_TAGS.PLAN(planId)]),

  /**
   * Force refresh account data in background while serving cached data
   */
  refreshAccount: (accountId: string) => api.util.invalidateTags([CACHE_TAGS.ACCOUNT(accountId)]),

  /**
   * Clear all cache for this API
   */
  clearCache: () => api.util.resetApiState(),
});
